import {Flex, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {WarningIcon} from '@eksab/features/competition/lineup/icons';

export const WarningIndicator = () => {
  const t = useTranslate();

  return (
    <Flex flexDir="column" align="flex-end">
      <WarningIcon boxSize="1.375rem" color="red.600" />

      <Text as="span" color="#FFEB00" fontSize="x-small" fontWeight="700">
        {t('fantasy.lineup.invalid-player.warning')}
      </Text>
    </Flex>
  );
};
